//region :: Imports ::
import React, {ReactNode} from 'react';
import MComponent from '../Component';

//endregion

/** */
type Props = {
    companyName: string;
    version: string;
}

/** */
class MFooter extends MComponent<Props> {

    /** */
    public render(): ReactNode {

        return (
            <div className="mshell-footer">
                <span className="font-medium ml-2">&copy; 2023 {this.props.companyName}.&nbsp;&nbsp;</span>
                <span className="text-small text-600">v{this.props.version}</span>
            </div>
        );

    }

}

export default MFooter;
